import React from 'react';
import server from '../../server';
import PatientCard from '../patients/PatientCard';

class AttendDetails extends React.Component{
    state = {
        status: 0,
        fisioterapistOpinion: 0,
        release: false
    }

    validate = () =>{
        if(this.state.status == 0) return this.props.alert("Falta Informações!","Selecione um status para a consulta","warning");
        if(this.props.current_appointment && this.props.current_appointment.lastAppointment == true && this.state.fisioterapistOpinion == 0) return this.props.alert("Falta Informações!", "Selecione uma opinião final", "warning");

        this.attend();
    }

    attend = () =>{
        if(this.state.status != 0){
            let object = {"status":this.state.status,"internalCommentary":this.state.internalCommentary};

            if(this.props.current_appointment && this.props.current_appointment.lastAppointment == true )
                object = {...object,...{ 
                    "released": this.state.release,
                    "messageToDoctor": this.state.commentary_doctor,
                    "messageToFisioterapist": this.state.commentary_fisioterapist,
                    "messageToPatient": this.state.commentary_patient,
                    "fisioterapistOpinion": this.state.fisioterapistOpinion,
                    "lastAppointment": true}};

            if(this.state.files)
                Array.from(this.state.files).forEach((file) =>{
                    let fileReader = new FileReader();
                    fileReader.onload = (data) => {
                        let req = {"file":data.target.result.split(",")[1],
                                "fileType":data.target.result.split(",")[0].split("/")[1].split(";")[0]};

                        server.post("appointments/" + this.props.current_appointment.batchId + "/media", req, (data) =>{
                            console.log("file uploaded")
                        })
                    };
                    fileReader.readAsDataURL(file); 
                });

            server.put("appointments/" + this.props.current_appointment.id,object,(data)=> {
                this.props.alert("Sucesso!","Sua Consulta foi atendida com sucesso","success");

                this.props.close();
                this.props.reset();
            });
        }
    }

    onChange = (event) =>{
        this.setState({[event.target.id]: event.target.value});
    }

    render(){
        let hide = this.props.open ? {top:"0"} : {top:"100%"};
        return(
            <div style={hide} class="app-modal bgc-white mobile-scroll ">
                <div class="w-100p clinic-data ">
                    <div class="w-100p ai-c jc-sb b-0">
                        <div class="col-md-12 peers jc-c pY-30 bdB">

                        </div>
                        <button onClick={this.props.close} type="button" class="modal-toogle btn btn-clear pX-5 pY-0 pos-a t-15 r-0 bdrs-2 cur-p c-client-secondary">
                            <i class="material-icons">close</i>
                        </button>

                        <div class="clearfix"></div>
                    </div>
                    <div class="scrollable">
                        <div class="content-data peers  ai-c jc-c">
                            <div class="attendance-register mT-20">
                                <form>
                                    <div class="form-group col-md-12 m-0 p-0">
                                        <div class="form-group col-md-6 m-0 p-0">
                                            <div class="col-md-12">
                                            <h4 class="m-0  mB-10">
                                                    <i class="fa fa-comment mR-10 mB-10 c-client-default"></i>{this.props.current_appointment ? server.fullDateString(this.props.current_appointment.date) : ""}</h4>
                                                <h4 class="m-0  mB-10">
                                                    <i class="fa fa-user mR-10 mB-10 c-client-default"></i>Dados do Paciente</h4>

                                                <div class="pB-0 peers ai-c bdB mB-10 pB-20">
                                                    <img class="w-10r bdrs-50p user-image bdc-client-default" src={server.imagePath + "/profile/" + this.props.data.profilePicture} alt=""/>
                                                    <div class="mL-20">
                                                        <h4 class="m-0">
                                                            <b>{this.props.data.name}</b>
                                                        </h4>
                                                        <p class="m-0 c-client-secondary">
                                                            <i class="fa fa-envelope  c-client-default"></i>{this.props.data.email}</p>
                                                        <p class="m-0  c-client-secondary">
                                                            <i class="fa fa-phone  c-client-default"></i>{this.props.data.telephone}</p>
                                                        <p class="m-0  c-client-secondary">
                                                            <i class="fa fa-hourglass  c-client-default"></i>{this.props.current_appointment ? this.props.current_appointment.date : ""}</p>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12">
                                                    <div class="clearfix"></div>
                                                    <div class="form-group col-xs-6">
                                                        <label for="inputName">
                                                            <b>CPF</b>
                                                        </label>
                                                        <p>{this.props.data.cpf}</p>
                                                    </div>
                                                    <div class="form-group col-xs-6">
                                                        <label for="inputName">
                                                            <b>Estado civil</b>
                                                        </label>
                                                        <p>{this.props.data.civilState == null ? "Não Definido" : server.civilStates[this.props.data.civilState]}</p>
                                                    </div>
                                                    <div class="form-group col-xs-6">
                                                        <label for="inputName">
                                                            <b>Profissão</b>
                                                        </label>
                                                        <p>{this.props.data.profession == null ? "Não Definido" : this.props.data.profession}</p>
                                                    </div>
                                                    <div class="form-group col-sm-6">
                                                        <label for="inputName">
                                                            <b>E-mail: </b>{this.props.data.email}
                                                        </label>
                                                    </div>
                                                    <div class="form-group col-xs-12">
                                                        <p>
                                                            <label for="inputName">
                                                                <b>Dt. Nasc: </b>{this.props.data.birthDate == null ? "Não Definido" : server.fullDateString(this.props.data.birthDate)}
                                                                <span class="c-client-secondary"></span>
                                                            </label>

                                                        </p>
                                                    </div>
                                                    <div class="form-group col-sm-12">
                                                        <label for="inputName">
                                                            <b>Endereço</b>
                                                        </label>
                                                        <p>{this.props.data.street}, {this.props.data.number} - {this.props.data.neighborhood} - {this.props.data.city} - {this.props.data.uf}</p>
                                                        <p>
                                                            <b>Complemento:</b> {this.props.data.complement}</p>
                                                        <p>
                                                            <b>CEP:</b> {this.props.data.cep}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group col-md-6">
                                            <div class="clearfix"></div>
                                            <h4 class="m-0  mB-10">
                                                <i class="fa fa-user mR-10 mB-10 c-client-default"></i>
                                                Fotos e Vídeos
                                            </h4>
                                            <div class="form-group bdB pX-10 mB-10 col-sm-12 w-100p">
                                                <input type="file" onChange={(event) => this.setState({files: event.target.files}, () => console.log(this.state.files))} multiple/>
                                                <br/>
                                            </div>
                                            <div>
                                                <div class="clearfix"></div>
                                                <h4 class="m-0  mB-10">
                                                    <i class="fa fa-comment mR-10 mB-10 c-client-default"></i>Comentários</h4>
                                                    <div style={{borderBottom:"1px solid rgba(0, 0, 0, 0.0625)",paddingBottom: 20}} class="form-group col-xs-12">
                                                        <label for="inputCep">Algum comentário interno para histórico desse paciente?</label>
                                                        <textarea id="internalCommentary" onChange={this.onChange} class="form-control" rows="4" name="internalCommentary" placeholder="Algum comentário interno?" />
                                                    </div>
                                                    {this.props.current_appointment && this.props.current_appointment.lastAppointment == true ?
                                                    <div>
                                                        {this.props.current_appointment.doctorId != null ?
                                                        <div class="form-group col-xs-12">
                                                            <label for="inputCep">Algum comentário para o médico?</label>
                                                            <textarea onChange={this.onChange} id="commentary_doctor" class="form-control" rows="4" name="toDoctor" placeholder="Algum comentário para o médico?" />
                                                        </div>
                                                        : <div></div>}
                                                        <div class="form-group col-xs-12">
                                                            <label for="inputCep">Algum para o paciente ou responsável?</label>
                                                            <textarea id="commentary_patient" onChange={this.onChange} class="form-control" rows="4" name="toDoctor" placeholder="Algum comentário para o médico?" />
                                                        </div>
                                                    
                                                        <div style={{borderBottom:"1px solid rgba(0, 0, 0, 0.0625)",paddingBottom: 20, display:"flex"}} class="form-group pX-10 mB-10 col-sm-12 w-100p">
                                                            <div class="form-group pX-10 mB-10 col-sm-12 w-100p">
                                                                <div class="radio radio-client-default">
                                                                    <input onClick={() => this.setState({fisioterapistOpinion: 1})} checked={this.state.fisioterapistOpinion == 1} type="radio" name="alta" id="radio1-1" value="alta"/>
                                                                    <label for="radio1-1">Alta</label>
                                                                </div>
                                                                <div class="radio radio-client-default">
                                                                    <input onClick={() => this.setState({fisioterapistOpinion: 2})} checked={this.state.fisioterapistOpinion == 2} type="radio" name="fisioterapia" id="radio1-2" value="fisioterapia"/>
                                                                    <label for="radio1-2">Necessita mais consultas terapeuticas</label>
                                                                </div>
                                                                <div class="radio radio-client-default">
                                                                    <input onClick={() => this.setState({fisioterapistOpinion: 3})} checked={this.state.fisioterapistOpinion == 3} type="radio" name="medico" id="radio1-3" value="medico"/>
                                                                    <label for="radio1-3">Necessita mais consultas médicas</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> 
                                                : <div></div>}
                                            </div>
                                            <div style={{padding:0}} class="form-group bdB pX-10 mB-10 col-sm-12 w-100p">
                                                <div class="radio radio-client-default">
                                                    <input onClick={() => this.setState({status: 1})} checked={this.state.status == 1} type="radio" name="atendimento" id="radio-1" value="Atendi"/>
                                                    <label for="radio-1">Atendi</label>
                                                </div>
                                                <div class="radio radio-client-default">
                                                    <input onClick={() => this.setState({status: 2})} checked={this.state.status == 2} type="radio" name="atendimento" id="radio-2" value="desmarcou"/>
                                                    <label for="radio-2">Desmarcou com antecedência</label>
                                                </div>
                                                <div class="radio radio-client-default">
                                                    <input onClick={() => this.setState({status: 3})} checked={this.state.status == 3} type="radio" name="atendimento" id="radio-3" value="falta"/>
                                                    <label for="radio-3">Falta cobrada</label>
                                                </div>
                                            </div>
                                            <div class="form-group ta-c col-xs-12">
                                                <button onClick={this.validate} class="btn btn-client-default" type="button">Concluir</button>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="clearfix"></div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

class AttendFisioterapist extends React.Component{
    state = {
        filter:"",
        patients:[],
        patient: {},
        key:0,
        open: false
    }

    componentWillMount(){
        this.loadPatients();
    }

    loadPatients = () =>{
        this.setState({patients:[]}, () =>
        server.get("fisioterapists/" + server.user.id + "/patients", (data) =>{
            data.forEach((patient) =>{
                server.get("fisioterapists/" + server.user.id + "/patients/" + patient.id + "/nextAppointment",(data) =>{
                    if (data != null){
                        let patients = this.state.patients;
                        patients.push(<PatientCard onClick={() => this.setState({open:true,patient:patient, current_appointment: data})} key={patient.name + "/?/" + patient.cpf} data={patient} />);
                        this.setState({patients:patients})
                    }
                });
            });
        }));
    }

    filter = () =>{
        const filter = this.state.filter.toLowerCase();
        let filtered = [];
        this.state.patients.forEach(appointment =>{
            const split = appointment.key.split("/?/");
            const name = split[0].toLowerCase();
            const cpf = split[1].toLowerCase();

            if(name.indexOf(filter) != -1 || cpf.indexOf(filter) != -1) filtered.push(appointment);
        })
        
        return filtered;
    }


    render(){
        let filtered = this.filter();
        return(
            <div key={this.state.key} class="col1-app">
                <div class="col1-app__wrapper">
                    <div class="col1-list h-100p">
                        <div style={{padding: "0px 10px"}} class="peers w-100p ai-c jc-sb content-header">
                            <div class="d-n@sm-">
                                <button type="button" class="page-side-toggle d-n@md+ btn btn-clear pX-5 pY-0  bdrs-2 mR-10 cur-p c-client-secondary">
                                    <i class="material-icons">vertical_split</i>
                                </button>
                                <div class="content-header__title">
                                    <h3 class="m-0">
                                        Atender Pacientes <span class="c-client-default fsz-sm"> ({this.state.patients.length})</span>
                                    </h3>
                                </div>
                            </div>

                            <div class="btn-group gap-10 w-100p jc-c" role="group">
                                <div class="p-10 peers jc-c">
                                    <div class="input-search-area">
                                        <input onChange={(event) => this.setState({filter:event.target.value})} class="m-0 w-100p input-muted  bdc-client-secondary bgc-grey-200" type="text" placeholder="Buscar por CPF ou nome" />
                                    </div>
                                    <div class="clearfix"></div>
                                </div>
                            </div>
            
                            <div class="btn-group gap-10 jc-c" role="group">
                                <button class="open-details btn btn-clear peers ai-c pX-5 pY-0 mB-5 bdrs-2 mR-5 cur-p c-client-default" type="button">
                                    <i class="fa fa-filter fsz-xl"></i>
                                    Filtrar
                                </button>
                            </div>
                        </div>
                        <div class="scrollable h-100p">
                            <div class="content-data peers  ai-c jc-c">
                                {filtered}
                            </div>
                            <AttendDetails open={this.state.open}
                                           close={()=>this.setState({open:false})}
                                           reset={()=>this.loadPatients()} 
                                           alert={this.props.alert} 
                                           current_appointment={this.state.current_appointment} 
                                           data={this.state.patient}/>
                        </div>
                    </div>
                    <div class="bcg-overlay open-details"></div>
                </div>
                <div class="col1-app__side-details jc-fs bdL bgc-white mobile-scroll">
                    <div class="inner-content ">
                        <div>
                            <div class="w-100p ta-c  h-100p">
                                <h3 class="ta-c mB-0">Filtro</h3>
                                <span class="fsz-xs c-client-secondary"></span>
                                <hr class="small bdc-client-default mY-10"/>
                            </div>

                            <button type="button" class="open-details btn btn-clear pX-5 pY-0 pos-a t-20 r-10 bdrs-2 cur-p c-client-secondary">
                                <i class="material-icons">close</i>
                            </button>
                        </div>
                        <div class="p-10 mobile-scroll scrollable">

                            <div class="p-10 peers ai-c jc-sb  w-100p">
                                <div class="p-10  w-100p bdB">
                                    <div class="p-0 w-100p">
                                        <label>Período</label>
                                    </div>
                                    <div class="form-group pR-10 pL-0 mB-10 col-sm-6 date-time-input">
                                        <label>Início</label>
                                        <input class="form-control" name="inputDate" type="date"/>
                                    </div>
                                    <div class="form-group  m-0 pR-10 pL-0 col-sm-6 date-time-input">
                                        <label>Fim</label>
                                        <input class="form-control" name="inputDate" type="date"/>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group pX-10 mB-10 col-sm-12 w-100p">
                                <div class="p-0 w-100p">
                                    <label>Período</label>
                                </div>
                                <div class="form-group mB-10 col-sm-6 w-100p">
                                    <div class="radio radio-client-default">
                                        <input type="radio" name="periodo" id="radio-periodo-1" value="Mensal"/>
                                        <label for="radio-periodo-1">Mensal</label>
                                    </div>
                                    <div class="radio radio-client-default">
                                        <input type="radio" name="periodo" id="radio-periodo-2" value="Trimestral"/>
                                        <label for="radio-periodo-2">Trimestral</label>
                                    </div>
                                    <div class="radio radio-client-default">
                                        <input type="radio" name="periodo" id="radio-periodo-3" value="Semestral"/>
                                        <label for="radio-periodo-3">Semestral</label>
                                    </div>
                                    <div class="radio radio-client-default">
                                        <input type="radio" name="periodo" id="radio-periodo-4" value="Anual"/>
                                        <label for="radio-periodo-4">Anual</label>
                                    </div>
                                </div>
                            </div>

                            <div class="pX-10 w-100p">
                                <div class="p-0 w-100p">
                                    <label>Médico</label>
                                </div>
                                <div class="form-group mB-10 col-sm-6 w-100p">
                                    <div class="checkbox checkbox-circle checkbox-client-default ai-c">
                                        <input id="jose" name="jose" type="checkbox"/>
                                        <label class="ai-c" for="jose">
                                            <span class="peer peer-greed">Jose</span>
                                        </label>
                                    </div>
                                    <div class="checkbox checkbox-circle checkbox-client-default ai-c">
                                        <input id="alfredo" name="alfredo" type="checkbox"/>
                                        <label class="ai-c" for="alfredo">
                                            <span class="peer peer-greed">Alfredo</span>
                                        </label>
                                    </div>
                                    <div class="checkbox checkbox-circle checkbox-client-default ai-c">
                                        <input id="salomao" name="salomao" type="checkbox"/>
                                        <label class="ai-c" for="salomao">
                                            <span class="peer peer-greed">Dr. Salomão</span>
                                        </label>
                                    </div>
                                    <div class="checkbox checkbox-circle checkbox-client-default ai-c">
                                        <input id="cancelado" name="cancelado" type="checkbox"/>
                                        <label class="ai-c" for="cancelado">
                                            <span class="peer peer-greed">Cancelado</span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="bdT p-10 peers jc-c ai-c bgc-client-default">
                            <button class="open-details fsz-xs btn btn-clear peers ai-c pX-5 pY-0 bdrs-2 mR-3 cur-p c-client-default-inverse" type="button">
                                Aplicar filtro
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default AttendFisioterapist;


// WEBPACK FOOTER //
// ./src/pages/attend/AttendFisioterapist.js